// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__4Y1et","disabled":"FileBtn_disabled__1oy3K","warn":"FileBtn_warn__15RAi","fade":"FileBtn_fade__2uaOB"};